export const HISTORY_MUTATIONS = {};

export const HISTORY_ACTIONS = {};

export const HISTORY_GETTERS = {
  GET_LATEST_STATUS: 'GET_LATEST_STATUS',
  GET_LATEST_STATUS_ALL_SYMPTOMS: 'GET_LATEST_STATUS_ALL_SYMPTOMS'
};
